module.exports = __webpack_public_path__ + "static/img/label-05.787db63.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/shipping-label/j_t/label-05.png
// module id = 7WbU
// module chunks = 150